import React from "react";
import { useCart } from "~/hooks/cartContext";

function CartButton({ mobile = false }: { mobile?: boolean }) {
  const { items } = useCart();
  const totalItems = items.reduce((sum, i) => sum + i.quantity, 0);

  const className = mobile ? "Mobile-overlay-nav-item" : "Header-nav-item";

  return (
    <button
      className={className}
      onClick={() => document.dispatchEvent(new Event("toggle-cart"))}
    >
      🛒 {totalItems > 0 && `(${totalItems})`}
    </button>
  );
}

export default CartButton;
